// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/neustadt-hilft/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const neustadtHilftDE: PageEntry = {
  id: "post.neustadt-hilft",
  locale: "de",
  slug: "neustadt-hilft",
  seo: {
    title: "Neustadt hilft! - Übergabe der Sachspenden | Dietz GmbH",
    description: "Neustadt hilft! - Übergabe der Sachspenden",
  },
  type: "post",
  h1: "Neustadt hilft! - Übergabe der Sachspenden",
  blocks: [
    { kind: "heading", level: 2, text: "Neustadt hilft! – Übergabe der Sachspenden" },
    { kind: "paragraph", text: "Erstmals seit über 60 Jahren gibt es Krieg in Europa. Das Leid der Menschen im Kriegsgebiet ist enorm. Wir unterstützen die Menschen, die am schlimmsten betroffen sind durch Care-Pakete und Sachspenden." },
    { kind: "paragraph", text: "Wir möchten dem BRK Neustadt für die Sachspenden in Form von Betten, Rollstühlen und Erste-Hilfe-Sets danken. Ebenso danken wir der Apotheke am Arnoldplatz für die Spende von Erste-Hilfe-Sets." },
    { kind: "paragraph", text: "Freitag, den 13.05.2022, gingen die Spenden auf Ihre Reise in die Stadt Perejaslaw, rund 90km südlich von Kiew." },
    { kind: "paragraph", text: "Unser großer Dank gilt allen Spenderinnen und Spendern, die in Form von Geld- und Sachspenden unterstützen, allen freiwilligen Helfern und natürlich auch allen beteiligten Unternehmen! Wir danken ebenfalls allen Mitarbeitern, die diese Aktion mit Spenden unterstützt haben!" },
    { kind: "paragraph", text: "Die Aktion „Neustadt hilft“ wurde von Neustadter Unternehmen und Gewerbetreibenden ins Leben gerufen. Vielen Dank an alle Beteiligten." },
    { kind: "paragraph", text: "– Apotheke am Arnoldsplatz – Feinkost Bauer – Buchhandlung Stache – Dietz GmbH – Druckerei Nötzold – Gölkel Bedachungen – Spedition Heland – Bauzentrum Hein Langguth – Klößerei – Renner Kunststofftechnik – Sauer Polymertechnik Neustadt" }
  ],
};
